export default {
    state: {
      alert: false,
    },
    mutations: {
      setAlert: (state, payload) => (state.alert = payload),
    },
  };
  